import React from "react";
import { Reveal, Check, scrollToPricing } from "./shared";
import { HERO_IMG, HERO_LOGO } from "./content";

export function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Man with glowing spine showing back pain"
          className="w-full h-full object-cover object-[72%_center] brightness-[1.35] contrast-[1.05]"
          data-testid="hero-image"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#040814] via-[#040814]/55 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#040814]/70 via-transparent to-transparent" />
      </div>

      <div className="absolute top-20 right-5 sm:right-8 z-20 sm-only">
        <div className="flex items-center gap-3 rounded-xl border border-[#22D3EE]/20 bg-[#0A1530]/70 backdrop-blur-md px-4 py-3">
          <svg className="w-6 h-6 text-[#22D3EE] shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinecap="round" strokeLinejoin="round"/></svg>
          <div className="leading-tight">
            <div className="text-[11px] font-bold tracking-[0.12em] text-white">GET LASTING RELIEF.</div>
            <div className="text-[10px] tracking-[0.12em] text-[#7C8FA8]">LIVE PAIN FREE.</div>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-8 pt-28 pb-16">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-7">
            <div>
              <img
                src={HERO_LOGO}
                alt="Freedom From Back Pain"
                className="w-52 sm:w-64 lg:w-72 h-auto mb-3 -ml-2 drop-shadow-[0_0_40px_rgba(59,130,246,0.45)]"
                data-testid="hero-logo"
              />
              <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold leading-[0.95] tracking-tight text-white uppercase">
                End Back Pain.<br />Transform Your Life.<br />
                <span className="text-[#3B82F6]">Forever.</span>
              </h1>
              <p className="text-base sm:text-lg text-[#C7D6EA] mt-7 max-w-md">
                The proven 4-week system to overcome back pain, restore your strength, and reclaim your freedom.
              </p>
              <div className="flex flex-wrap gap-x-7 gap-y-3 mt-7 text-sm text-white">
                {["Relieve pain fast", "Fix the root cause", "Stay pain free for life"].map((x) => (
                  <span key={x} className="inline-flex items-center gap-2"><Check className="text-[#3B82F6]" />{x}</span>
                ))}
              </div>
              <div className="mt-9">
                <button
                  onClick={scrollToPricing}
                  data-testid="hero-cta"
                  className="group w-full max-w-xl rounded-lg text-left px-8 py-6 bg-gradient-to-r from-[#F59E0B] to-[#F97316] text-white shadow-[0_14px_44px_rgba(249,115,22,0.45)] hover:-translate-y-0.5 transition-transform"
                >
                  <div className="font-display text-xl sm:text-2xl font-extrabold tracking-tight uppercase">Get Instant Access Now</div>
                  <div className="text-[11px] sm:text-xs tracking-[0.22em] font-semibold opacity-90 mt-1.5 uppercase">Start Your Transformation Today</div>
                </button>
                <div className="mt-4 text-[11px] tracking-[0.16em] text-[#9AAEC6] inline-flex items-center gap-2 uppercase">
                  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                  One Click. Instant Access. Lifetime Benefits.
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
